import React, { useState } from 'react';
import styles from "./SellerTemplate.module.css";
import deleteicon from "../../icons/delete.png";
import edit from "../../icons/edit.png";
import { Link } from "react-router-dom";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import { baseUrlDefiner } from "../../utils/config";
import axios from "axios";

const displayContactNumber = (value) => String(value ?? '').replace(/^91(?=\d{10}$)/, '');

export default function SellerTemplate({ data, sellerDelete }) {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedSeller, setSelectedSeller] = useState(null);
    const [sellerdata, setsellerdata] = useState(null);
    const [shopdata, setshopdata] = useState(null);
    const [businessdata, setbusinessdata] = useState(null);
    const [servicedata, setservicedata] = useState(null);

    const showModal = () => setIsModalVisible(true);
    const handleOk = () => setIsModalVisible(false);
    const handleCancel = () => setIsModalVisible(false);

    async function showdata(seller_id) {
        const apiEndpoint = baseUrlDefiner();
        try {
            const result = await axios({
                url: `${apiEndpoint}/check_live`,
                method: 'POST',
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                data: { seller_id }
            });

            const responseData = result?.data?.data;
            if (responseData && typeof responseData === "object") {
                setSelectedSeller(responseData);
                setsellerdata(responseData);
                setshopdata(responseData);
                setbusinessdata(responseData);
                setservicedata(responseData);
                showModal();
            }

        } catch (error) {
            const errMsg = error?.response?.data?.error?.[0]?.message;
            toast.error(`${errMsg} for ${error?.response?.data?.error?.[0]?.email}`);
        }
    }



    return (
        <>
            {data.map((item) => (
                <div className={`d-flex justify-content-between w-100 ${styles.sellerTemplatemain}`} key={item.id}>
                    <div className={styles.sellerTemplateDesc}>
                        <p className="m-0">{item.company_name}</p>
                        <div className={styles.sellerTemplateDesc_mail}>
                            <p className='m-0 mb-1'>{item.email}</p>
                        </div>
                        <div>
                            <p className='m-0'>{displayContactNumber(item.contact_no)}</p>
                        </div>
                        {(item.approve_status === 1)
                            ? <button className={styles.success}>Approved</button>
                            : (item.approve_status === 2)
                                ? <button className={styles.danger}>Blocked</button>
                                : <button>New Request</button>}
                    </div>

                    <div className={styles.sellerTemplateButtons}>
                        <div>
                            <Link to={`../../updateseller/${item.id}`} className="btn-sm m-1 btn btn-success btn-circle">
                                <div><img src={edit} alt="Edit" /></div>
                            </Link>
                        </div>

                        <div>
                            <span
                                className="badge badge-secondary btn-sm w-100"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    const url = `/login?navigateToSeller=true&token=${sessionStorage.getItem("us_st_d")}&provider_id=${item.provider_id}&email=${item.email}`;
                                    window.location.href = url;
                                }}
                            >
                                Log In
                            </span>

                        </div>

                        <div>
                            <button
                                className="btn btn-success btn-sm mt-1"
                                onClick={() => showdata(item.id)}
                            >
                                View
                            </button>
                        </div>
                    </div>
                </div>
            ))}

            <AntModal
                className="custom-left-modal"
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                width={320}
                mask={false}


            >
                <div style={{ overflowX: 'auto', padding: "0px" }}>
                    <div className="p-2 "  >
                        <h2 className="text-xl font-bold mb-4">Seller</h2>
                        <div className="max-h-[500px] overflow-y-auto border border-gray-300 rounded-md p-2 space-y-6 overflow-x-scroll">

                            {/* Seller Section */}
                            <table className="w-full border border-gray-300 text-sm">
                                <thead>
                                    <tr className="bg-gray-100">
                                        <th className="px-2 py-1 border text-left">Field</th>
                                        <th className="px-2 py-1 border text-left">Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr><td className="border px-2 py-1">Company Name</td><td className="border px-2 py-1">{selectedSeller?.seller?.company_name}</td></tr>
                                    <tr><td className="border px-2 py-1">GST No</td><td className="border px-2 py-1">{selectedSeller?.seller?.gst_no}</td></tr>
                                    <tr><td className="border px-2 py-1">PAN No</td><td className="border px-2 py-1">{selectedSeller?.seller?.pan_no}</td></tr>
                                    <tr><td className="border px-2 py-1">Contact No</td><td className="border px-2 py-1">{displayContactNumber(selectedSeller?.seller?.contact_no)}</td></tr>
                                </tbody>
                            </table>

                            {/* User Section */}
                            <h2 className="text-xl font-semibold mb-2">User</h2>
                            <table className="w-1/2 border border-gray-300 text-sm">
                                <tbody>
                                    <tr><td className="border px-2 py-1">Name</td><td className="border px-2 py-1">{sellerdata?.user?.name}</td></tr>
                                    <tr><td className="border px-2 py-1">Email</td><td className="border px-2 py-1">{sellerdata?.user?.email}</td></tr>
                                    <tr><td className="border px-2 py-1">Contact No</td><td className="border px-2 py-1">{displayContactNumber(sellerdata?.user?.contact_no)}</td></tr>
                                </tbody>
                            </table>

                            {/* Shop Section */}
                            <h2 className="text-xl font-semibold mb-2">Shop</h2>
                            <table className="w-full border border-gray-300 text-sm">
                                <tbody>
                                    <tr><td className="border px-2 py-1">Opening Days</td><td className="border px-2 py-1">{shopdata?.shop?.opening_days}</td></tr>
                                    <tr><td className="border px-2 py-1">COD</td><td className="border px-2 py-1">{shopdata?.shop?.cod ? "Yes" : "No"}</td></tr>
                                    <tr><td className="border px-2 py-1">Image</td><td className="border px-2 py-1"><img src={shopdata?.shop?.images} alt="Shop" style={{ width: "100px" }} /></td></tr>
                                </tbody>
                            </table>

                            {/* Service Section */}
                            <h2 className="text-xl font-semibold mb-2">Service</h2>
                            <table className="w-full border border-gray-300 text-sm">
                                <tbody>
                                    <tr><td className="border px-2 py-1">Service Type</td><td className="border px-2 py-1">{servicedata?.service?.service_type || "N/A"}</td></tr>
                                </tbody>
                            </table>

                            {/* Business Section */}
                            <h2 className="text-xl font-semibold mb-2">Business</h2>
                            <table className="w-full border border-gray-300 text-sm">
                                <tbody>
                                    <tr>
                                        <td className="border px-2 py-1">Business</td>
                                        <td className="border px-2 py-1">
                                            {businessdata?.bussiness?.length > 0
                                                ? businessdata.bussiness.join(", ")
                                                : "N/A"}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </AntModal>

        </>
    );
}
